import React from 'react'
import { Box } from '@mui/material'
import { TeacherProvider } from 'common/context/TeacherContext'
import { Routes, Route } from 'react-router-dom'

import Awakening from './awakening'
import AwakeningStepperComponent from './awakening/stepper'
import TermsOfServiceComponent from './awakening/termsOfService'
import AwakeningSigninConfirmation from './awakening/SigninConfirmation'
import RestartPrograms from './restart-programs'
import ConfirmRestartModal from './restart-programs/ConfirmRestartModal'
import ProgramSettings from './program-settings'
import SchoolReport from './schoolReport'

function TeacherApp() {
  return (
    <TeacherProvider>
      <Routes>
        <Route
          path='/awakening/stepper'
          element={<AwakeningStepperComponent />}
        />
        <Route
          path='/awakening/signin-confirmation'
          element={<AwakeningSigninConfirmation />}
        />
        <Route path='/awakening' element={<Awakening />} />
        <Route path='/school-report' element={<SchoolReport />} />
        <Route
          path='/awakening/terms-of-service'
          element={<TermsOfServiceComponent />}
        />
        <Route path='/restart_programs' element={<RestartPrograms />} />
        <Route path='/program_settings' element={<ProgramSettings />} />
        <Route
          path='/restart_programs/confirmation'
          element={<ConfirmRestartModal />}
        />

        <Route path='*' element={<Box>Hello world! This is XM React</Box>} />
      </Routes>
    </TeacherProvider>
  )
}

export default TeacherApp
